import { useEffect, useState } from 'react';
import { i18nService, type LanguageType } from '../services/i18n';

/**
 * The current language, and a re-render whenever it changes.
 *
 * `i18nService` holds the language and notifies its subscribers, but a
 * component that only calls `i18nService.t()` during render does not
 * re-render by itself — the text it already rendered stays on screen. This
 * hook is the missing half: it subscribes to the service and returns the
 * language, so a component that uses it redraws with the new text.
 *
 * The language is also in the dependency list of the `useMemo`s that read it,
 * which is what makes the translated content follow.
 */
export function useLanguage(): LanguageType {
  const [language, setLanguage] = useState<LanguageType>(() => i18nService.getLanguage());

  useEffect(
    () => i18nService.subscribe(() => setLanguage(i18nService.getLanguage())),
    [],
  );

  return language;
}

export default useLanguage;
